<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.push('/menu')" class="ml-2 cursor-pointer">
                            <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Rutas de cobros</span>
                    </h4>
                    <div class="card-container m-b-30">
                        <div class="card-body">
                            <div class="bootstrapTable">
                                <div class="row font-weight-bold mb-2">
                                    <div class="col-12 col-sm-3">
                                        Asignado a
                                    </div>
                                    <div class="col-12 col-sm-3">
                                        Creado por
                                    </div>
                                    <div class="col-12 col-sm-3">
                                        Fecha creación
                                    </div>
                                    <div class="col-12 col-sm-2">
                                        Fecha de ruta
                                    </div>
                                    <div class="col-12 col-sm-1">

                                    </div>
                                </div>
                                <div class="row bootstrapTableRow" v-for="item in rutaCobros">
                                    <div class="col-12 col-sm-3">
                                        {{item.username}}
                                    </div>
                                    <div class="col-12 col-sm-3">
                                        {{item.createdBy}}
                                    </div>
                                    <div class="col-12 col-sm-3">
                                        {{item.dateCreated}}
                                    </div>
                                    <div class="col-12 col-sm-2">
                                        {{item.dateRuta}}
                                    </div>
                                    <div class="col-12 col-sm-1">
                                        <a :href="'/ruta-cobros-create/' + item.id" v-if="parseInt(item.estado) > 0">
                                            <i class="fa fa-pencil"></i>
                                        </a>
                                    </div>
                                </div>

                                <div class="text-right mt-4">
                                    <a href="/ruta-cobros-create/0" type="button" class="btn btn-primary btn__crear">Crear ruta</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";


export default {
    props: {},
    components: {
        Pago,
        //TimelineChart,
        Layout,
        //Toster,
        InicioPago
    },
    data() {
        return {
            Valid: {},

            rutaCobros: {},
            editing: {
                asignado: '',
                nit: '',
                dpi: '',
                direccion: '',
                telefono: '',
                observaciones: '',
            }
        };
    },
    watch: {
        // whenever question changes, this function will run
        descuento: function (monto) {
            this.monto = monto;

            if (parseFloat(this.montoOriginal) > parseFloat(monto)) {
                this.numeroPagos = 1;
                this.numeroDisabled = true;
            }
            else {
                this.numeroDisabled = false;
            }
        }
    },
    mounted() {

        const self = this;

        API.send('POST', 'ruta/cobro/lista', {
              },
            function (response) {
                store.dispatch('coreHideLoading');

                if (typeof response.status !== 'undefined') {

                    if (response.status) {
                        self.rutaCobros = response.data;
                    }
                    else {
                        alert(response.msg);
                    }
                }
                else {
                    alert(response.msg);
                }
            },
            function () {
                store.dispatch('coreHideLoading');
                alert('Error al realizar operación, por favor intente de nuevo');
            })
    },
    methods: {
        Numbro,
        dayjs,
        crearRecobro() {

        }
    },
};
</script>
